import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Heading } from '@/components/ui/typography';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Button } from '@/components/ui/button';
import { Stack } from '@/components/ui/layout';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';

const Achievements = ({ onUpdate, existingAchievements = [] }) => {
  const [achievements, setAchievements] = useState(existingAchievements);

  useEffect(() => {
    // Ensure achievements is always an array
    setAchievements(existingAchievements || []);
  }, [existingAchievements]);

  const handleAchievementChange = (index, field, value) => {
    const updatedAchievements = [...achievements];
    updatedAchievements[index] = { ...updatedAchievements[index], [field]: value };
    setAchievements(updatedAchievements);
    onUpdate(updatedAchievements);
  };

  const addAchievement = () => {
    const newAchievement = { title: '', description: '' };
    const updatedAchievements = [...achievements, newAchievement];
    setAchievements(updatedAchievements);
    onUpdate(updatedAchievements);
  };

  const removeAchievement = (index) => {
    const updatedAchievements = achievements.filter((_, i) => i !== index);
    setAchievements(updatedAchievements);
    onUpdate(updatedAchievements);
  };

  return (
    <Card className="mb-6 bg-white">
      <CardContent className="p-4">
        <Heading level="h2" className="text-base font-semibold mb-3">Achievements</Heading>
        <Stack spacing="md">
          {achievements && achievements.length > 0 ? (
            achievements.map((achievement, index) => (
              <div key={index} className={cn("space-y-4 p-4 border rounded-lg")}>
                <Label>Achievement {index + 1}</Label>
                <Input
                  type="text"
                  placeholder="Achievement Title"
                  value={achievement.title}
                  onChange={(e) => handleAchievementChange(index, 'title', e.target.value)}
                />
                <Textarea
                  placeholder="Achievement Description"
                  value={achievement.description}
                  onChange={(e) => handleAchievementChange(index, 'description', e.target.value)}
                />
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => removeAchievement(index)}
                  className="text-destructive self-end"
                >
                  <X className="w-4 h-4 mr-2" />
                  Delete Achievement
                </Button>
              </div>
            ))
          ) : (
            <p className="text-muted-foreground">No achievements added yet.</p>
          )}

          <Button variant="outline" onClick={addAchievement} className="w-full">
            Add Achievement
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default Achievements;